/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Og_TitleInputs */

const en_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | A Better Way To Swing`)
};

const es_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Una mejor forma de hacer swing`)
};

const de_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Eine bessere Art zu schwingen`)
};

const zh_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 更好的挥杆方式`)
};

const ar_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | طريقة أفضل للسوينغ`)
};

const fr_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Une meilleure façon de swinguer`)
};

const vi_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Một cách swing tốt hơn`)
};

const sw_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Njia Bora ya Kupiga Swing`)
};

const th_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | วิธีที่ดีกว่าในการสวิง`)
};

const bs_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Bolji način zamaha`)
};

const ja_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | スイングのより良い方法`)
};

const ko_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 더 나은 스윙 방법`)
};

const pt_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Um jeito melhor de fazer o swing`)
};

const it_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Un modo migliore di fare swing`)
};

const sv_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Ett bättre sätt att svinga`)
};

const nl_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Een betere manier om te swingen`)
};

const da_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | En bedre måde at svinge på`)
};

const nb_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | En bedre måte å svinge på`)
};

const fi_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Parempi tapa swingata`)
};

const pl_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Lepszy sposób na swing`)
};

const ru_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Лучший способ делать свинг`)
};

const tr_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Sving İçin Daha İyi Bir Yol`)
};

const hi_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | स्विंग का बेहतर तरीका`)
};

const id_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Cara Lebih Baik Melakukan Ayunan`)
};

const ms_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Cara Lebih Baik untuk Menghayun`)
};

const cs_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Lepší způsob golfového švihu`)
};

const el_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Ένας καλύτερος τρόπος για σβινγκ`)
};

const he_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | דרך טובה יותר לסווינג`)
};

const af_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 'n Beter manier om te swaai`)
};

const hu_meta_og_title = /** @type {(inputs: Meta_Og_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Jobb módja a swingnek`)
};

/**
* | output |
* | --- |
* | "Mark Egly Golf \| A Better Way To Swing" |
*
* @param {Meta_Og_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const meta_og_title = /** @type {((inputs?: Meta_Og_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Og_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_og_title(inputs)
	if (locale === "de") return de_meta_og_title(inputs)
	if (locale === "zh") return zh_meta_og_title(inputs)
	if (locale === "ar") return ar_meta_og_title(inputs)
	if (locale === "fr") return fr_meta_og_title(inputs)
	if (locale === "vi") return vi_meta_og_title(inputs)
	if (locale === "sw") return sw_meta_og_title(inputs)
	if (locale === "th") return th_meta_og_title(inputs)
	if (locale === "bs") return bs_meta_og_title(inputs)
	if (locale === "ja") return ja_meta_og_title(inputs)
	if (locale === "ko") return ko_meta_og_title(inputs)
	if (locale === "pt") return pt_meta_og_title(inputs)
	if (locale === "it") return it_meta_og_title(inputs)
	if (locale === "sv") return sv_meta_og_title(inputs)
	if (locale === "nl") return nl_meta_og_title(inputs)
	if (locale === "da") return da_meta_og_title(inputs)
	if (locale === "nb") return nb_meta_og_title(inputs)
	if (locale === "fi") return fi_meta_og_title(inputs)
	if (locale === "pl") return pl_meta_og_title(inputs)
	if (locale === "ru") return ru_meta_og_title(inputs)
	if (locale === "tr") return tr_meta_og_title(inputs)
	if (locale === "hi") return hi_meta_og_title(inputs)
	if (locale === "id") return id_meta_og_title(inputs)
	if (locale === "ms") return ms_meta_og_title(inputs)
	if (locale === "cs") return cs_meta_og_title(inputs)
	if (locale === "el") return el_meta_og_title(inputs)
	if (locale === "he") return he_meta_og_title(inputs)
	if (locale === "af") return af_meta_og_title(inputs)
	if (locale === "hu") return hu_meta_og_title(inputs)
	return en_meta_og_title(inputs)
});